import React from 'react';

import I18n from 'components/translate/I18n';

import './BetaBadge.scss';

const BetaBadge = () => (
  <div className="beta-badge _d-flex _align-items-center _justify-content-center _bg-blue-lightest">
    <p className="beta-badge__label _text-blue-darker _font-weight-bold _text-1">
      <I18n label="general.beta" />
    </p>
  </div>
);

export default BetaBadge;
